<template>
    <div>
        <p v-if="false === data">
            Something went wrong. Please refresh the page and try again.
        </p>
        <base-loader v-else-if="!data" />
        <slot v-else />
    </div>
</template>

<script>

export default {
    props: {
        /* eslint-disable-next-line vue/require-prop-types */
        data: {
            default: null,
        },
    },
};
</script>
